<template>
  <div>
    <Headtop :isbanner="false"/>
    <div class="loginbox flex-center">
      <div class="formbox">
        <h1>找回密码</h1>
        <el-form ref="form" class="login-form" :model="seeker" :rules="rules" label-width="100px">
          <el-form-item label="手机号码：" prop="name">
            <el-input placeholder="请输入手机号码" v-model="seeker.name"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="email">
            <el-input placeholder="请输入电子邮箱" v-model="seeker.email" type="email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="loginbtn" :loading="loading" @click="onSubmit()">找回密码</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>

import {mapActions} from 'vuex'
import {checkEmail} from "@/utils/validate"
import Vue from "vue";
import {postAction,getAction} from "@/api/manage"

export default {
  data() {
    return {
      seeker: {},
      loading: false,
      getTime: 0, //第一次点击时间
      rules: {
        name : [{
          required: true, message: "请输入手机号码", trigger: "blur"},
          {validator: function(rule, value, callback)
            {if (/^1[3456789]\d{9}$/.test(value) == false) {
              callback(new Error("格式必须为手机号"));
            } else {
              callback();
            }
            },
            trigger: "blur"
          }],
        email: [{required: true, message: '请输入电子邮箱', trigger: 'blur'}, {validator: checkEmail, trigger: 'blur'}],
      },
      isread: false,
      url:{
        forgotPwd: '/email/forgotPwd',
      },
    };
  },
  methods: {
    onSubmit () {
    this.getCurrentTime()
    },
    getCurrentTime() {
      var _this = this;
      //秒级
      let time = new Date().getTime()/1000

      if(_this.getTime == 0){
        _this.getTime = time;
      } else {
      if(time - _this.getTime < 60){//s为单位
          this.$message.error("请你在1分钟后再点击")
          _this.getTime = time;
          return
        }
      }
      postAction(this.url.forgotPwd,{name: this.seeker.name,email: this.seeker.email}).then((res) =>{
        if (res.success){
          this.$message.success("新密码已发送至您的邮箱")
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped></style>
